<div class="modal-header">
  <span class="modal-title">{{title}}</span>
  <button type="button" class="btn-close " aria-label="Close" (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
<div class="settings-container flex flex-column">
  <ng-container *ngIf="!dataForm">
    <div class="item-list" *ngFor="let item of data | keyvalue">
      <app-settings-list
        [opened]="selected === item?.key"
        [noOpenedContent]="true"
        [noEditDeleteBar]="readonly"
        (editClicked)="doEdit(item?.key)"
        (deleteClicked)="doDelete(item?.key)">

        <app-manage-airport-terminal-dialog-list-item
          [opened]="selected === item?.key"
          [item]="item.value"
          [shallNotOpen]="readonly"
          (click)="selected = item?.key">
        </app-manage-airport-terminal-dialog-list-item>

      </app-settings-list>
    </div>
  </ng-container>
<!--  <ng-container *ngIf="dataForm">-->
<!--    <div class="item-list" *ngFor="let item of dataForm | keyvalue">-->

<!--      <app-settings-list-->
<!--        [opened]="selected === item?.key"-->
<!--        [noOpenedContent]="true"-->
<!--        [noEditDeleteBar]="readonly"-->
<!--        (editClicked)="doEdit(item)"-->
<!--        (deleteClicked)="doDelete(item?.key)">-->

<!--        <app-manage-airport-terminal-dialog-list-item-->
<!--          [opened]="selected === item?.key"-->
<!--          [item]="item.value"-->
<!--          [shallNotOpen]="readonly"-->
<!--          (click)="selected = item?.key">-->
<!--        </app-manage-airport-terminal-dialog-list-item>-->

<!--      </app-settings-list>-->
<!--    </div>-->
<!--  </ng-container>-->
  <app-add-row *ngIf="!readonly" (addClicked)="doAdd()"></app-add-row>
</div>
</div>
